<template>
	<div id="app" v-loading.body="isLoading" :class="[deviceClass]">
		<router-view />
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { updateSurveyHost } from './config';

export default {
	components: {},
	data() {
		return {
			deviceClass: '',
		};
	},
	created() {
		if (
			navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			)
		) {
			this.deviceClass = 'isMobile';
		} else {
			this.deviceClass = 'isPc';
		}
	},

	computed: {
		...mapState({
			isLoading: (state) => state.app.isLoading, //|| state.app.dataLoading,
			userInfo: (state) => state.user.userInfo, //|| state.app.dataLoading,
		}),
	},
	async mounted() {
		const currentRouter = this.$router.resolve(location.hash.slice(1));
		if (currentRouter.route.name !== 'questionnaireVote') {
			const searchData = this.getSearchData(location.href);
			let params = {};
			if (searchData && searchData.ticket) {
				params = {
					ticket: searchData.ticket,
				};
			}
			try {
				await this.getUserInfo(params);
				// 调用 getUserDomain 获取用户域名
				if (this.userInfo && this.userInfo.id) {
					await this.getUserDomain(this.userInfo.id);
					// 更新 config.js 中的 surveyHost
					updateSurveyHost(this.$store.state.user.userDomain);
				}

				if (searchData && searchData.ticket) {
					this.$router.replace({
						name: 'questionnaire',
					});
				}
			} catch (error) {
				console.error(error);
			}
		}
		window.scrollTo(0, 0);
	},

	methods: {
		...mapActions({
			getUserInfo: 'user/getUserInfo',
			getUserDomain: 'user/getUserDomain',
		}),
		getSearchData(href) {
			// 首先判断是否存在search内容;
			if (href && href.indexOf('?') !== -1) {
				// 首先解析href，将?后的内容取出
				const searchUrl = href.substring(href.indexOf('?') + 1);
				let obj = {};
				searchUrl.split('&').forEach((element) => {
					const list = element.split('=');
					if (list.length === 1) {
						// 说明不是准备的query数据
						return false;
					} else {
						// 判读当前的ticket内容是否存在#, 存在则说明回调地址拼接有误
						const ticket = list[1].indexOf('#') !== -1 ? list[1].replace(/#.*/, '') : list[1];
						obj[list[0]] = ticket;
					}
				});
				return obj;
			}
			return false;
		},
	},
	watch: {
		$route(val) {
			document.title = val.meta.title || '内容工具';
		},
	},
};
</script>
<style lang="less">
.icon {
	width: 1em;
	height: 1em;
	vertical-align: -0.15em;
	fill: currentColor;
	overflow: hidden;
}
.iconpark-icon {
	width: 1em;
	height: 1em;
}
html {
	height: 100%;
}
* {
	box-sizing: border-box;
	padding: 0;
	margin: 0;
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
body {
	font-family: 'PingFang SC', '微软雅黑', 'Microsoft YaHei', Helvetica, 'Helvetica Neue', Tahoma, Arial, sans-serif;
	margin: 0;
	height: 100%;
	width: 100%;
}
ul,
ol {
	list-style: none;
}
.clearFix {
	&:after {
		content: '';
		width: 0;
		height: 0;
		display: block;
		clear: both;
	}
}
.el-tabs__nav-wrap::after {
	height: 1px;
}
#app {
	height: 100%;
	&.isPc {
		min-width: 1200px;
	}
}

.el-pagination {
	text-align: right;
	padding: 20px;
	font-weight: normal;
	.btn-prev,
	.btn-next,
	.el-pager li {
		border: 1px solid #d9d9d9;
		border-radius: 4px;
		box-sizing: border-box;
		min-width: 28px;
	}
	.btn-prev {
		margin-right: 4px;
		padding-right: 4px;
		&:hover {
			color: #1890ff;
			border: 1px solid #1890ff;
		}
	}
	.btn-next {
		padding-left: 4px;
		&:hover {
			color: #1890ff;
			border: 1px solid #1890ff;
		}
	}
	.el-pager {
		li {
			margin-right: 4px;
			&:hover {
				color: #1890ff;
				border: 1px solid #1890ff;
			}
			&.active {
				color: #1890ff;
				border: 1px solid #1890ff;
			}
		}
	}
}

th {
	font-weight: normal;
}

.el-dialog__close {
	color: rgba(78, 89, 105, 1) !important;
	font-size: 20px;
	&:hover {
		color: #409eff;
	}
}

.el-button--primary {
	background: #2c7dfa;
	border-color: #2c7dfa;
	&:hover {
		background: #409eff;
        color: #fff !important;
	}
}
.el-button--default {
    &:hover {
		color: #2c7dfa;
	}
}
.el-checkbox {
    .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #2c7dfa;
        border-color: #2c7dfa;
    }
}
.el-tabs {
    .el-tabs__item.is-active {
        color: #2c7dfa;
    }
    .el-tabs__active-bar {
        background: #2c7dfa;
    }
}
</style>
